<!--
 * @Description: 服务事项新增模板dialog组件
 * @Author: sunhuihong
 * @Date: 2022-05-23 14:43:52
 * @LastEditTime: 2022-05-31 17:19:22
-->
<template>
  <el-dialog width="640px" :title="dialogTitle" :visible.sync="showAddTemplateDialog" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel" center>
    <el-form class="form" ref="serviceTemplateForm" :model="serviceTemplateForm"  label-width="120px">
      <el-form-item prop="name" label="名称" :rules="[
         { required: true, message: '请输入模板名称', trigger: 'blur' },
         { min:1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'change'
        }]">        
        <el-input size="small"  v-model.trim="serviceTemplateForm.name" maxlength="10" autocomplete="off" 
          style="width: 320px" placeholder="请输入模板名称" >
        </el-input>  
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('serviceTemplateForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: "AddTemplateDialog",
  props: ["showAddTemplateDialog", "mode", "serviceItemId" , "parentId", "institutionId"],
  data() {
    return {
      serviceTemplateForm: {},
    };
  },
  computed: {
    dialogTitle() {
      switch (this.mode) {
        case 'add'    : return "新增模板名称";
        case 'edit'   : return "编辑模板名称";
        default       : return "----";
      } 
    },
  },
  
  methods: {
    //获取编辑接口数据
    initData() {
      if (this.mode == "edit") {
        let params = {id: this.serviceItemId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_MATTER,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.serviceTemplateForm = result.data == null ? {} : result.data;
          }
        });
      }
    },

    //清空
    clearData() {
      this.serviceTemplateForm = {};
      this.$nextTick(() => {
        this.$refs["serviceTemplateForm"].clearValidate();
      });
    },

    //确定提交表单接口调用
    handleSubmit(serviceTemplateForm) {
      this.$refs[serviceTemplateForm].validate((valid) => {
        if (!valid) return false;
        let url = this.mode == 'add' ? Constant.URL_SAVE_MATTER : Constant.URL_UPDATE_MATTER;
        let method = this.mode == 'add' ? 'POST' : 'PUT';
        this.serviceTemplateForm.institutionId = this.institutionId;
        this.serviceTemplateForm.parentId = this.parentId;
        let header = this.encryptionUtil.signatureBody(this.serviceTemplateForm,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: this.serviceTemplateForm,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };

        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.clearData();
            this.$emit("handle-close-template-dialog", true);
          }
        });
      });
    },

    handleCancel() {
      this.clearData();
      this.$emit("handle-close-template-dialog", false);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/hsvcmng/components/hsvcmatter/AddTemplateDialog.vue